import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import { Content, Section, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import bg from "../../styles/images/signup_bg.png";
import cat from "../../styles/images/cat.png";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import { Modal } from "../../components/modal/Modal";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";

const DanalResponse = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const validatePage = JSON.parse(sessionStorage.getItem("page")) || "";
  const signUpInfoData = useSelector((state) => state.auth.signUpInfo);

  useEffect(() => {
    //callback 값 체크이후에
    //result == true(1) 이면 스토어 저장 후 이용약관페이지로 이동
    //아니면  모달 이후 sign-up 으로
    const result = searchParams.get("result");
    const tid = searchParams.get("tid");
    const name = searchParams.get("name");
    const phone = searchParams.get("phone");
    const birth = searchParams.get("birth");
    const gender = searchParams.get("gender");
    const email = searchParams.get("email");
    const params = {
      tid: tid,
      name: name,
      phone: phone,
      birth: birth,
      gender: gender,
      email: email,
    };
    if (validatePage.path == "/sign-up") {
      if (result == 1 && !email) {
        dispatch(authActions.setSignUpInfo(params));
      } else {
        if (email) {
          navigate(validatePage.path, {
            state: { result: false, reason: "email" },
          });
        } else {
          navigate(validatePage.path, { state: { result: false, reason: "" } });
        }
      }
    } else if (validatePage.path == "/find/id") {
      if (result == 1) {
        navigate("/find/id/result", { state: { result: true, userId: email } });
      } else {
        navigate("/find/id/result", { state: { result: false, userId: "" } });
      }
    } else if (validatePage.path == "/find/password") {
      if (result == 1) {
        navigate("/find/password/result", {
          state: { result: true, userId: email, tid: tid },
        });
      } else {
        navigate("/find/password/result", {
          state: { result: false, userId: email, tid: tid },
        });
      }
    } else if (validatePage.path == "/mypage/edit") {
      if (result == 1 && email) {
        //성공
        navigate(validatePage.path, {
          state: { result: true, params: params },
        });
        ///mypage/edit페이지로 가면 비밀번호 다시 입력해야함..성공해서 돌아갈땐 재입력 안해야함..
      } else {
        //실패
        navigate(validatePage.path, { state: { result: true, params: {} } });
      }
    }
  }, []);

  useDidMountEffect(() => {
    if (signUpInfoData != {}) {
      navigate("/sign-up/terms-of-use");
    }
  }, [signUpInfoData]);

  return (
    <OnePageLayout title="본인인증 결과">
      <Section>
        <Content>
          <TextDiv>
            <h3>잠시만 기다려주세요.</h3>
          </TextDiv>
        </Content>
      </Section>
    </OnePageLayout>
  );
};

export default DanalResponse;
